// Typed wrappers around /api/v1/admin/complaints/*.

import type {
  PublicComplaint,
  ComplaintStatus,
  ComplaintCategory,
  ComplaintVisibility,
  SortOrder,
  ResolveComplaintRequest,
} from '@residenone/shared';
import { api } from './api-client';

export type {
  PublicComplaint,
  ComplaintStatus,
  ComplaintCategory,
  ComplaintVisibility,
  SortOrder,
  ResolveComplaintRequest,
};

export interface ListComplaintsParams {
  limit?: number;
  cursor?: string;
  status?: ComplaintStatus;
  category?: ComplaintCategory;
  visibility?: ComplaintVisibility;
  block?: string;
  this_month?: boolean;
  user_id?: string;
  sort?: SortOrder;
}

export async function listAdminComplaints(
  params: ListComplaintsParams,
): Promise<{ items: PublicComplaint[]; nextCursor: string | null }> {
  const { data } = await api.get<{ items: PublicComplaint[]; nextCursor: string | null }>(
    '/admin/complaints',
    { params },
  );
  return data;
}

export async function getAdminComplaint(id: string): Promise<PublicComplaint> {
  const { data } = await api.get<{ complaint: PublicComplaint }>(`/admin/complaints/${id}`);
  return data.complaint;
}

export async function markInProgress(id: string): Promise<PublicComplaint> {
  const { data } = await api.post<{ complaint: PublicComplaint }>(
    `/admin/complaints/${id}/in-progress`,
  );
  return data.complaint;
}

export async function resolveComplaint(
  id: string,
  input: ResolveComplaintRequest,
): Promise<PublicComplaint> {
  const { data } = await api.post<{ complaint: PublicComplaint }>(
    `/admin/complaints/${id}/resolve`,
    input,
  );
  return data.complaint;
}
